// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/AiCredits_AdminByFranchiseResponse.php
// Do not edit by hand — edit the PHP ResponseContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * Staff-family admin by-franchise response — cost fields allowed.
 * Full-gated only.
 */
import type { AiCredits_AdminByFranchiseRow } from './AiCredits_AdminByFranchiseRow'
import type { ApiResponse } from '../services/httpService'
import { registerResponseContract } from './validate'

export interface AiCredits_AdminByFranchiseResponseDados {
period: string
rows: AiCredits_AdminByFranchiseRow[]
}

export type AiCredits_AdminByFranchiseResponse = ApiResponse<AiCredits_AdminByFranchiseResponseDados>;

registerResponseContract('AiCredits_AdminByFranchiseResponse', {
  period: { type: 'string',  required: true },
  rows: {
    type: 'array',
    required: true,
    items: {
      franquia_id:       { type: 'number',  required: true },
      franquia_name:     { type: 'string',  required: true },
      balance_micro:     { type: 'number',  required: true },
      total_micro:       { type: 'number',  required: true },
      cogs_realized_usd: { type: 'string',  required: true },
      settle_count:      { type: 'number',  required: true },
    },
  },
})
